<script>
    // import { onMount } from 'svelte';
	// import { CircleDot, CircleStop, Check } from 'lucide-svelte';
    // import Meter from '$lib/Meter.svelte';
	// export let data;
	// let { supabase, session, user_roles } = data
	// $: ({ supabase, session, user_roles } = data)
    // let roles = user_roles?.map( (x) => x.role );
    // let all_kits = [];
    // let kit;

    // import { stream_store } from '$lib/stores'
    // let stream;
    // stream_store.subscribe( (x) => stream = x );

	// const ldcjs = 'https://cdn.jsdelivr.net/gh/Linguistic-Data-Consortium/ldcjs@0.2.3/src';
	// let set_audio_element_with_url;
	// let play_src_with_audio_id;
	// let getUserMedia;
	// let create_blob;
	// let filename_from_date;
	// let create_node_graph;
	// let get_audio_context;
	// let new_builder;

	// let stream_record = 'stream';
	// let streaming = false;
	// let record = false;
	// let recording_object = {};
    // let chunks = [];
    // let blob = null;
    // let filename = '';


	// onMount( async () => {
	// 	const m = await import(`${ldcjs}/request_animation_frame_loop.js`);
	// 	m.request_animation_frame_loop_init();

	// 	window.ldc.vars.loop.set('time_callback', timef);
	// 	const module = await import(`${ldcjs}/audio/main.js`);
	// 	set_audio_element_with_url = module.set_audio_element_with_url;
	// 	play_src_with_audio_id = module.play_src_with_audio_id;
	// 	getUserMedia = module.getUserMedia;
	// 	create_blob = module.create_blob;
	// 	filename_from_date = module.filename_from_date;
	// 	create_node_graph = module.create_node_graph;
	// 	get_audio_context = module.get_audio_context;
	// 	const { WaveRiff } = await import(`${ldcjs}/audio/wave_riff.js`);
	// 	new_builder = () => new WaveRiff('builder');
    // });

    // let start_time = 0;
	// let seconds = 0;
	// function timef(){
	// 	if(start_time) seconds = (Date.now() - start_time)/1000;
	// }

    // async function check(){
    //     if(roles?.includes('admin')){
    //         let { data: channels, error } = await supabase
    //             .from('kits')
    //             .select('*')
    //         console.log(channels);
    //         all_kits = channels;
    //         kit = all_kits.filter( (x) => x.state == 'assigned' );
    //         kit.sort( (a,b) => a.created_at - b.created_at ); // toSorted not available server side
    //         kit = kit[0];
    //     }
    // }
    // check();


	// $: show_recording = chunks.length;
	// let show_recorder = true;


	// let meter_level = 0;
	// // the data processing function sets an RMS value in a meter
	// const analyzef = (time_domain, freq_domain) => meter_level = rms(time_domain);
	// // const analyzef = () => console.log('here');
	// const onstopf = () => console.log('done');

	// let audio_context;
	// async function audio_context_init(){
	// 	if(!audio_context){
	//  		audio_context = get_audio_context();
	//     	await audio_context.resume();
	// 		await audio_context.audioWorklet.addModule('recording_processor.js');
	// 	}
	// 	return audio_context;
	// }

	// async function start_simple(){
    //     const fn = filename_from_date();
    //     filename = `${fn}`;
	// 	start_recording(stream_record);
	// }

    // function start_simple2(){
    //     stream_record = 'record';
    //     const fn = filename_from_date();
    //     filename = `${fn}`;
	// 	start_recording(stream_record);
    // }

	// async function start_recording(stream_record){
	// 	start_time = Date.now();
    //     streaming = true;
    //     if(stream_record == 'record'){
    //         record = true;
	// 		await audio_context_init();
    //     }
    //     const script_processor = false;
    //     const audio_worklet = true;
    //     recording_object = create_node_graph({
    //         stream,
    //         record,
    //         onstopf,
    //         analyzef,
    //         script_processor,
    //         audio_worklet
    //     });
    //     // the following assignment is what sets the callback to be called

    //     window.ldc.vars.loop.set('stream_callback', recording_object.analyze);

	// 	if(recording_object.worklet){
	// 		recording_object.worklet.port.onmessage = (e) => {
	// 			console.log(e);
	// 			chunks = e.data;
	// 	        if(chunks.length){
    //     		    blob = create_blob(chunks, new_builder());
    //         		console.log(blob);
    //     		}
	// 		}
	// 	}
    //     else{
    //         console.log('no worklet');
    //     }
    // }

	// function stop_simple(){
	// 	stop_recording();
	// }

    // let uploading = 0;
    // async function stop_simple2(){
	// 	stop_recording();
    //     uploading = 1;
    //     await upload();
    //     uploading = 2;
	// }

    // function stop_recording(){
	// 	start_time = 0;
    //     streaming = false;
    //     record = false;
    //     // stream = null;
	// 	if(recording_object){
	// 		recording_object.destroy();
	// 		window.ldc.vars.loop.delete('stream_callback'); // stop callback
	// 	}
    // }

	// function rms(time_domain){
	// 	let sum = 0;
	// 	for(let i = 0; i < time_domain.length; i++){
	// 		let v = Math.abs(time_domain[i]);
	// 		sum += v * v;
	// 	}
	// 	return Math.sqrt(sum / time_domain.length);
	// }

    // let levels_ok = false;

    // function upload(){
    //     if(blob) upload2();
    //     else setTimeout(upload, 500);
    // }

    // async function upload2(){
    //     if(!blob) return;
    //     await upload3(blob);
    //     blob = null;
    // }

    // async function upload3(file){
    //     // const fn = `test${Math.random().toString.substring(2,12)}.wav`
    //     const fn = `uploads/${filename}.wav`
    //     const { data, error } = await supabase.storage.from('audio').upload(fn, file)
    //     if (error) {
    //         console.error(error)
    //     } else {
    //         console.log('done')
    //     }
    // }

    // const words = [
    //     'door', 'sock', 'anchor', 'table', 'dice', 'garage', 'leaf', 'saw', 'king', 'elephant', 'cat', 'skis', 'well', 'fork', 'fireplace',
    //     'shoe', 'fish', 'pumpkin', 'butterflys', 'scissors', 'bone', 'piano', 'sun', 'hair', 'crutches', 'microscope', 'plant', 'house',
    //     'celery', 'pear', 'cheerleaders', 'crown', 'typewriter', 'window', 'rake', 'ghost', 'van', 'seal', 'pillow', 'chair', 'nose', 'ruler',
    //     'whistle', 'camel', 'harp', 'volcano', 'bridge', 'octopus', 'bed', 'owl', 'wig', 'basket', 'ball', 'duck', 'skull', 'hand', 'can',
    //     'map', 'vest', 'necklace', 'camera', 'banana', 'ambulance', 'grapes', 'pig', 'nurse', 'star', 'spoon', 'bowl', 'dog', 'tractor',
    //     'kite', 'squirrel', 'sailor', 'iron', 'heart', 'pineapple', 'snail', 'cannon', 'towel', 'cow', 'ear', 'broom', 'toilet', 'hammer',
    //     'mountain', 'bench', 'flashlight', 'queen', 'pen', 'suit', 'horse', 'comb', 'monkey', 'key', 'fireman', 'corn', 'frog', 'belt',
    //     'dinosaur', 'cane', 'church', 'flower', 'eye', 'hose', 'tent', 'man', 'scale', 'pencil', 'tree', 'mustache', 'turkey', 'drum',
    //     'football', 'bottle', 'snake', 'top', 'pipe', 'lion', 'cross', 'candle', 'chimney', 'balloon', 'zipper', 'cowboy', 'nail', 'train',
    //     'goat', 'vase', 'stethoscope', 'wagon', 'scarf', 'bus', 'letter', 'bat', 'boot', 'calendar', 'knife', 'book', 'cake', 'bread',
    //     'binoculars', 'bride', 'Eskimo', 'dragon', 'clown', 'slippers', 'waterfall', 'helicopter', 'sandwich', 'zebra', 'bell', 'rope',
    //     'clock', 'ring', 'beard', 'carrot', 'spider', 'hat', 'desk', 'apple', 'pie', 'glove', 'pyramid', 'kitchen', 'lamp', 'pirate',
    //     'baby', 'glass', 'closet', 'thermometer', 'foot', 'saddle', 'strawberries', 'fan'
    // ];

</script>

<div class="w-96 mx-auto p-8 space-y-8 grid-cols-12 gridx">

    
   

</div>
